import { useEffect } from 'react';

const SITE = 'GoldCrusade';

/** Sets the document title and meta description for a route. */
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    document.title =
      title === SITE ? `${SITE} — AI assistants, practical implementation, ongoing consulting` : `${title} · ${SITE}`;
    if (description) {
      document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    }
  }, [title, description]);
}
